export enum FormInputStyle {
    Stacked = 1,
    Floating = 2,
    Row = 3
}
